import Vue from 'vue'
import Router from 'vue-router'

import index from '@/pages/index/index'
import services from '@/pages/services/services'
import warehousing from '@/components/warehousing/warehousing'
import diversifiedTransport from '@/components/diversifiedTransport/diversifiedTransport'
import internationalFreight from '@/components/internationalFreight/internationalFreight'
import valueAdded from '@/components/valueAdded/valueAdded'
import supplyChain from '@/components/supplyChain/supplyChain'
import moreServices from '@/components/moreServices/moreServices'

import industries from '@/pages/industries/industries'
import appliedMaterials from '@/components/appliedMaterials/appliedMaterials'
import paintCoating from '@/components/paintCoating/paintCoating'
import lubricatingOil from '@/components/lubricatingOil/lubricatingOil'
import agrochemical from '@/components/agrochemical/agrochemical'
import electronicChemical from '@/components/electronicChemical/electronicChemical'
import newEnergy from '@/components/newEnergy/newEnergy'
import chemicalReagent from '@/components/chemicalReagent/chemicalReagent'
import moreIndustries from '@/components/moreIndustries/moreIndustries'

import globalNet from '@/pages/globalNet/globalNet'
import eastChina from '@/components/eastChina/eastChina'
import northChina from '@/components/northChina/northChina'
import southwest from '@/components/southwest/southwest'
import southChina from '@/components/southChina/southChina'

import security from '@/pages/security/security'
import integrated from '@/components/integrated/integrated'
import institutional from '@/components/institutional/institutional'
import responsibilityLanding from '@/components/responsibilityLanding/responsibilityLanding'
import contingency from '@/components/contingency/contingency'
import characteristicDisplay from '@/components/characteristicDisplay/characteristicDisplay'

import technology from '@/pages/technology/technology'
import about from '@/pages/about/about'
import vision from '@/components/vision/vision'
import growthProcess from '@/components/growthProcess/growthProcess'
import glory from '@/components/glory/glory'
import responsibility from '@/components/responsibility/responsibility'

import contact from '@/components/contactUs/contactUs'
import news from "@/pages/news/news"
import partners from '@/pages/partners/partners'

import join from "@/pages/join/join"
import workChance from "@/components/workChance/workChance"
import work from "@/components/work/work"

import login from "@/pages/login/login"
// import { component } from 'vue/types/umd'
import kportal from '@/pages/kportal/kportal'
// import { compile, component } from 'vue/types/umd'
import staffLogin from '@/pages/staffLogin/staffLogin'

Vue.use(Router)

export default new Router({
  mode: 'history',
  //mode:'hash',
  // base: 'demo/',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {keepAlive: true}
    }, {
      path: '/index',
      name: 'index',
      component: index,
      meta: {keepAlive: true}
    }, {
      path: '/services',
      name: 'services',
      component: services
    }, {
      path: '/services/warehousing',
      name: 'warehousing',
      component: services
    }, {
      path: '/services/diversifiedTransport',
      name: 'diversifiedTransport',
      component: services
    }, {
      path: '/services/internationalFreight',
      name: 'internationalFreight',
      component: services
    }, {
      path: '/services/valueAdded',
      name: 'valueAdded',
      component: services
    }, {
      path: '/services/supplyChain',
      name: 'supplyChain',
      component: services
    }, {
      path: '/services/moreServices',
      name: 'moreServices',
      component: services
    }, {
      path: '/industries',
      name: 'industries',
      component: industries
    }, {
      path: '/industries/appliedMaterials',
      name: 'appliedMaterials',
      component: industries
    }, {
      path: '/industries/paintCoating',
      name: 'paintCoating',
      component: industries
    }, {
      path: '/industries/lubricatingOil',
      name: 'lubricatingOil',
      component: industries
    }, {
      path: '/industries/agrochemical',
      name: 'agrochemical',
      component: industries
    }, {
      path: '/industries/electronicChemical',
      name: 'electronicChemical',
      component: industries
    }, {
      path: '/industries/newEnergy',
      name: 'newEnergy',
      component: industries
    }, {
      path: '/industries/chemicalReagent',
      name: 'chemicalReagent',
      component: industries
    }, {
      path: '/industries/moreIndustries',
      name: 'moreIndustries',
      component: industries
    }, {
      path: '/globalNet',
      name: 'globalNet',
      component: globalNet,
    }, {
      path: '/globalNet/eastChina',
      name: 'eastChina',
      component: globalNet
    }, {
      path: '/globalNet/northChina',
      name: 'northChina',
      component: globalNet
    }, {
      path: '/globalNet/southwest',
      name: 'southwest',
      component: globalNet
    }, {
      path: '/globalNet/southChina',
      name: 'southChina',
      component: globalNet
    }, {
      path: '/security',
      name: 'security',
      component: security
    }, {
      path: '/security/integrated',
      name: 'integrated',
      component: security
    }, {
      path: '/security/institutional',
      name: 'institutional',
      component: security
    }, {
      path: '/security/responsibilityLanding',
      name: 'responsibilityLanding',
      component: security
    }, {
      path: '/security/contingency',
      name: 'contingency',
      component: security
    }, {
      path: '/security/characteristicDisplay',
      name: 'characteristicDisplay',
      component: security
    }, {
      path: '/technology',
      name: 'technology',
      component: technology
    }, {
      path: '/technology/storageVisualization',
      name: 'storageVisualization',
      component: technology
    }, {
      path: '/technology/transportationVisualization',
      name: 'transportationVisualization',
      component: technology
    }, {
      path: '/technology/independentlySoftware',
      name: 'independentlySoftware',
      component: technology
    }, {
      path: '/technology/clientInterface',
      name: 'clientInterface',
      component: technology
    }, {
      path: '/about',
      name: 'about',
      component: about
    }, {
      path: '/about/vision',
      name: 'vision',
      component: about
    }, {
      path: '/about/growthProcess',
      name: 'growthProcess',
      component: about
    }, {
      path: '/about/glory',
      name: 'glory',
      component: about
    }, {
      path: '/about/qualifications',
      name: 'qualifications',
      component: about
    },{
      path: '/about/responsibility',
      name: 'responsibility',
      component: about
    }, {
      path: '/about/contact',
      name: 'contact',
      component: about
    },{
      path: '/about/partners',
      name: 'partners',
      component: about
    }, {
      path: '/news',
      name: 'news',
      component: news
    },{
      path: '/news/groupNews',
      name: 'groupNews',
      component: news
    },{
      path: '/news/industryDynamics',
      name: 'industryDynamics',
      component: news
    },{
      path: '/news/mediaCoverage',
      name: 'mediaCoverage',
      component: news
    }, {
      path: '/join',
      name: 'join',
      component: join
    }, {
      path: '/join/work',
      name: 'work',
      component: join
    },{
      path: '/join/workChance',
      name: 'workChance',
      component: join
    }, {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/kportal',
      name: 'kportal',
      component: kportal
    },
    {
      path: '/staffLogin',
      name: 'staffLogin',
      component: staffLogin
    }
    
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js